import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import config from "./config";

class Reporting extends Component {
  render() {
    return <Menu {...config} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: {
      ...state.intl.messages.containers.features.reporting,
      ...state.intl.messages.containers.litterMemberFeatures
        .litterMemberReporting,
      landing: {
        ...state.intl.messages.containers.litterMemberFeatures
          .litterMemberReporting.landing,
        title: state.intl.messages.containers.features.reporting.landing.title,
        subtitle:
          state.intl.messages.containers.features.reporting.landing.subtitle,
        menuLink:
          state.intl.messages.containers.features.reporting.landing.menuLink,
      },
      reportCard: state.intl.messages.components.cards,
    },
    reporting: state.reducers.reporting,
  };
};

export default connect(mapStateToProps)(Reporting);
